import { type ReactNode } from 'react';
import '../tracking/events.quiz-bank';
import { createDomainTracking } from '@zep/logger/react';
import { useIsLoggerUserInfoSet } from '@/lib/auth/UserContext';
const {
  TrackImpression
} = createDomainTracking(() => ({}));

/*
  베타 진입점 발견율의 분모. 진입점은 노출 과목에서만 그려지므로 노출 자체가 "지원 조합에
  도달했다"는 뜻이고, 상한에 닿아 누를 수 없는 노출도 함께 센다. 마운트가 아니라 **보일 때**
  1회 — 문항 리스트 아래로 밀려 화면 밖에 있을 수 있다.

  유저 문맥이 실린 뒤에만 관측을 건다: 노출 관측은 첫 교차에서 발화 완료로 표시해 다시 쏘지
  않는데, React 는 자식 이펙트를 부모(`UserProvider`)보다 먼저 돌려 게이트 없이 걸면 이
  분모만 사용자·플랜 문맥 없이 저장된다.
*/
/**
 * 문제 은행 진입점 노출 계측 — 진입 카드를 감싸 관측한다. 모양·동작은 없다.
 */
export const QuizBankEntryImpression = ({
  isFull,
  remainingSlots,
  className,
  children
}: {
  isFull: boolean;
  remainingSlots: number;
  className?: string;
  children: ReactNode;
}) => {
  const isLoggerUserInfoSet = useIsLoggerUserInfoSet();
  if (!isLoggerUserInfoSet) return <div className={className}>{children}</div>;
  return <TrackImpression event="quiz_bank_entry_row_view" props={{
    place: 'build_entry_row',
    is_full: isFull,
    remaining_slot_count: remainingSlots
  }} className={className} data-sentry-element="TrackImpression" data-sentry-component="QuizBankEntryImpression" data-sentry-source-file="QuizBankEntryImpression.tsx">
      {children}
    </TrackImpression>;
};